import store from '@/store'

export const updateField = (prop: string, update: any, label: string = null, isNumber = false) => {
  if (isNumber && update < 0) return
  if (!label) label = prop
  store.dispatch('employmentApplicationUpdate', { prop, update, label, isNumber })
}
